import { RateCardRateBase, RateCardTermType } from '@bringg/types';
import { Condition } from 'features/conditions/rule/rule-utils';
import { DRIVING_DISTANCE_RULE_CONDITION_PATH } from '../consts';

const FLAT_RATE_BASE_OPTION = { name: 'Flat', id: RateCardRateBase.Flat };
const MILES_RATE_BASE_OPTION = { name: 'Miles', id: RateCardRateBase.Miles };
const UNITS_RATE_BASE_OPTION = { name: 'Units', id: RateCardRateBase.Units };
const WEIGHT_RATE_BASE_OPTION = { name: 'Weight', id: RateCardRateBase.Weight };
const MILES_SURPLUS_RATE_BASE_OPTION = { name: 'Miles surplus', id: RateCardRateBase.MilesSurplus };

const DEFAULT_RATE_BASE_OPTIONS = [
	FLAT_RATE_BASE_OPTION,
	MILES_RATE_BASE_OPTION,
	UNITS_RATE_BASE_OPTION,
	WEIGHT_RATE_BASE_OPTION
];

const hasDrivingDistanceCondition = (conditions: Condition[]): boolean => {
	return conditions.some(({ path }) => path === DRIVING_DISTANCE_RULE_CONDITION_PATH);
};

export const getAdjustedRateBaseWithOptions = (
	conditions: Condition[],
	rateBase: RateCardRateBase,
	rateType: RateCardTermType
): {
	adjustedRateBase: RateCardRateBase;
	rateBaseOptions: { name: string; id: RateCardRateBase }[];
} => {
	let adjustedRateBase = rateBase;
	let rateBaseOptions = [...DEFAULT_RATE_BASE_OPTIONS];

	if (hasDrivingDistanceCondition(conditions)) {
		if (rateType === RateCardTermType.Base) {
			adjustedRateBase = RateCardRateBase.Flat;
			rateBaseOptions = [FLAT_RATE_BASE_OPTION];
		} else {
			adjustedRateBase = RateCardRateBase.MilesSurplus;
			rateBaseOptions = [MILES_SURPLUS_RATE_BASE_OPTION];
		}
	}

	return { adjustedRateBase, rateBaseOptions };
};
